import type { StatusPillPaletteId } from 'ds';
import type { StatusPillOption } from 'ds';

import { AdminSupportTicketStatus } from './types';

/** Support ticket status → palette + label. Single source of truth for StatusPill display (same pattern as workOrderStatusConfig). */
export const SUPPORT_TICKET_STATUS_CONFIG: Record<
  AdminSupportTicketStatus,
  { paletteId: StatusPillPaletteId; label: string }
> = {
  open: { paletteId: 'gold', label: 'New' },
  closed: { paletteId: 'gray-light', label: 'Closed' },
  waiting_on_us: { paletteId: 'blue', label: 'Waiting on us' },
  waiting_on_contact: { paletteId: 'purple', label: 'Waiting on contact' }
};

/** Returns palette + label for a support ticket status pill. Spread into StatusPill (same pattern as getWorkOrderStatusPillProps). */
export function getSupportTicketStatusPillProps(status: AdminSupportTicketStatus): {
  palette: StatusPillPaletteId;
  label: string;
} {
  const { paletteId, label } = SUPPORT_TICKET_STATUS_CONFIG[status];
  return { palette: paletteId, label };
}

/** Dropdown options for support ticket status (used by status pill cell in table). */
export function getSupportTicketStatusMenuOptions(currentStatus: AdminSupportTicketStatus): StatusPillOption[] {
  const options: StatusPillOption[] = [];

  if (currentStatus === 'closed') {
    options.push(
      {
        value: 'waiting_on_us',
        label: 'Re-open (Waiting on us)',
        reopen: true,
        paletteId: SUPPORT_TICKET_STATUS_CONFIG.waiting_on_us.paletteId
      },
      {
        value: 'waiting_on_contact',
        label: 'Re-open (Waiting on contact)',
        reopen: true,
        paletteId: SUPPORT_TICKET_STATUS_CONFIG.waiting_on_contact.paletteId
      }
    );
  } else {
    options.push({
      value: 'closed',
      label: 'Close',
      paletteId: SUPPORT_TICKET_STATUS_CONFIG.closed.paletteId
    });

    if (currentStatus !== 'waiting_on_us') {
      options.push({
        value: 'waiting_on_us',
        label: 'Waiting on us',
        paletteId: SUPPORT_TICKET_STATUS_CONFIG.waiting_on_us.paletteId
      });
    }

    if (currentStatus !== 'waiting_on_contact') {
      options.push({
        value: 'waiting_on_contact',
        label: 'Waiting on contact',
        paletteId: SUPPORT_TICKET_STATUS_CONFIG.waiting_on_contact.paletteId
      });
    }
  }

  return options;
}
